export const SocialData = [
  {
    platform: "Github",
    icon: require("../../assets/icons/github.png"),
    link: "https://github.com/nikhilgupta15",
  },
  {
    platform: "Linkedin",
    icon: require("../../assets/icons/linkedin.png"),
    link: "https://www.linkedin.com/in/nikhil-gupta25/",
  },
];
